import { IAggregator } from '../../types/aggregator.types';
import { getSyncEndpoint } from '../getSyncEndpoint/getSyncEndpoint';

/****
 * Given an array of aggregators, determine whether the brand pulls product data from recipe management platform (e.g Assure65)
 * @param aggregators array of aggregators available on a brand
 * @return true if recipe management sync is enabled, false if not
 */
export const isProductSyncActive = (aggregators: IAggregator[]): boolean => {
  return !!getSyncEndpoint(aggregators);
};
